<template>
  <div>
    <!-- ============================================================
         Dialog Sửa thông tin tài chính khoản thu (API 7)
         Sử dụng: <edit-revenue-detail-dialog ref="editDetailDialog" @saved="onSaved" />
         Mở:     this.$refs.editDetailDialog.open(revenueItem)
         ============================================================ -->
    <dialog-base
      :visible.sync="visible"
      title="Chỉnh sửa khoản thu học sinh"
      size="lg"
      cancel-text="Hủy"
      confirm-text="Lưu lại"
      :confirm-loading="loading"
      :use-panel="false"
      top="6vh"
      @confirm="handleSubmit"
      @cancel="handleClose"
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="formRules"
        label-width="170px"
        label-position="left"
        class="sk-dialog-content"
      >
        <!-- ══════════════════════════════════════════
             PHÂN KHU 1 – THÔNG TIN KHOẢN THU (read-only)
             ══════════════════════════════════════════ -->
        <div class="sk-panel mb-4">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-document" /></div>
            <div>
              <p class="sk-panel-title">Thông tin khoản thu</p>
              <p class="sk-panel-subtitle">Thông tin cơ bản của khoản thu (chỉ xem)</p>
            </div>
          </div>

          <el-row :gutter="20">
            <!-- Tên khoản thu -->
            <el-col :span="24">
              <el-form-item label="Tên khoản thu">
                <div class="erd-readonly-value">{{ dataForm.revenueName || '—' }}</div>
              </el-form-item>
            </el-col>
            <!-- Mô tả -->
            <el-col v-if="dataForm.description" :span="24">
              <el-form-item label="Mô tả">
                <div class="erd-readonly-value erd-description">{{ dataForm.description }}</div>
              </el-form-item>
            </el-col>

<!--            &lt;!&ndash; Loại khoản &ndash;&gt;-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="Loại khoản">-->
<!--                <el-tag-->
<!--                  :type="dataForm.category === 'IN' ? 'success' : 'info'"-->
<!--                  size="small"-->
<!--                  effect="light"-->
<!--                >-->
<!--                  {{ dataForm.category === 'IN' ? 'Khoản thu' : 'Khoản chi' }}-->
<!--                </el-tag>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

<!--            &lt;!&ndash; Trạng thái &ndash;&gt;-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="Trạng thái">-->
<!--                <el-tag-->
<!--                  :type="dataForm.active ? 'success' : 'danger'"-->
<!--                  size="small"-->
<!--                  effect="light"-->
<!--                >-->
<!--                  {{ dataForm.active ? 'Đang kích hoạt' : 'Chưa kích hoạt' }}-->
<!--                </el-tag>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

<!--            &lt;!&ndash; Kiểu thời gian áp dụng &ndash;&gt;-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="Kiểu thời gian">-->
<!--                <el-tag size="small" effect="plain" type="warning">-->
<!--                  {{ appliedTimeTypeLabel }}-->
<!--                </el-tag>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

            <!-- Tính theo điểm danh -->
            <el-col :span="12">
              <el-form-item label="Tính theo điểm danh">
                <el-tag
                  :type="dataForm.attendance ? 'primary' : 'info'"
                  size="small"
                  effect="light"
                >
                  {{ dataForm.attendance ? 'Có' : 'Không' }}
                </el-tag>
              </el-form-item>
            </el-col>

            <!-- Áp dụng công thức -->
            <el-col :span="12">
              <el-form-item label="Áp dụng công thức">
                <el-tag
                  :type="dataForm.hasFormula ? 'primary' : 'info'"
                  size="small"
                  effect="light"
                >
                  {{ dataForm.hasFormula ? 'Có' : 'Không' }}
                </el-tag>
              </el-form-item>
            </el-col>

            <!-- Biểu thức công thức (chỉ hiển thị khi hasFormula = true) -->
            <el-col v-if="dataForm.hasFormula && dataForm.formulaExpression" :span="24">
              <el-form-item label="Biểu thức công thức">
                <div class="erd-readonly-value erd-formula">{{ dataForm.formulaExpression }}</div>
              </el-form-item>
            </el-col>

            <el-col v-if="dataForm.hasFormula && dataForm.formulaExpression" :span="24">
              <el-form-item>
                <template v-slot:label>
                  Công thức (đã dịch)
                  <el-tooltip content="Công thức với tên khoản thu thay thế biến" placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <div class="trf-formula-name">{{ dataForm.formulaExpressionName }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- ══════════════════════════════════════════
             PHÂN KHU 2 – TÀI CHÍNH GHI ĐÈ (editable)
             ══════════════════════════════════════════ -->
        <div class="sk-panel mb-4">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-money" /></div>
            <div>
              <p class="sk-panel-title">Tài chính ghi đè</p>
              <p class="sk-panel-subtitle">Điều chỉnh giá, số lượng và giảm giá riêng cho học sinh này</p>
            </div>
          </div>

          <el-row :gutter="20">
            <!-- Đơn giá -->
            <el-col :span="12" v-if="!dataForm.hasFormula">
              <el-form-item prop="price">
                <template v-slot:label>
                  Đơn giá (VNĐ)
                  <el-tooltip content="Đơn giá ghi đè cho học sinh này" placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <ElCurrencyInput
                  v-model="dataForm.price"
                  :options="{ locale: 'vi-VN', precision: 0, autoDecimalMode: false, distractionFree: false }"
                  class="sk-u-w-full"
                  @input="calculatePreview"
                />
              </el-form-item>
            </el-col>

            <!-- Số lượng -->
            <el-col :span="12">
              <el-form-item prop="quantity">
                <template v-slot:label>
                  Số lượng
                  <el-tooltip content="Số lượng đơn vị" placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <el-input
                  v-model.number="dataForm.quantity"
                  type="number"
                  :step="allowDecimal ? 0.01 : 1"
                  class="sk-u-w-full"
                  @input="calculatePreview"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Cho phép số thập phân">
                <el-switch
                  :value="allowDecimal"
                  active-text="Có"
                  inactive-text="Không"
                  @change="handleAllowDecimalChange"
                />
              </el-form-item>
            </el-col>

            <!-- Đơn vị tính -->
            <el-col :span="12">
              <el-form-item>
                <template v-slot:label>
                  Đơn vị tính
                  <el-tooltip content="Ví dụ: tháng, buổi, lần..." placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <el-select
                  v-model="dataForm.unit"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Chọn hoặc nhập đơn vị"
                  class="sk-u-w-full"
                >
                  <el-option v-for="u in unitsList" :key="u" :label="u" :value="u" />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Giảm giá -->
            <el-col :span="12">
              <el-form-item prop="discount">
                <template v-slot:label>
                  Giảm giá
                  <el-tooltip content="Bật nếu muốn áp dụng chính sách giảm giá riêng cho học sinh này" placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <el-radio-group v-model="dataForm.discount" @change="onDiscountChange">
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- Loại giảm giá -->
            <el-col v-if="dataForm.discount" :span="12">
              <el-form-item prop="discountType">
                <template v-slot:label>
                  Loại giảm giá
                  <el-tooltip content="Phần trăm (%) hoặc số tiền (VNĐ)" placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <el-select
                  v-model="dataForm.discountType"
                  placeholder="Chọn loại"
                  class="sk-u-w-full"
                  @change="calculatePreview"
                >
                  <el-option label="Phần trăm (%)" value="PERCENT" />
                  <el-option label="Số tiền (VNĐ)" value="MONEY" />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Giá trị giảm -->
            <el-col v-if="dataForm.discount" :span="12">
              <el-form-item prop="discountNumber">
                <template v-slot:label>
                  <span v-if="dataForm.discountType === 'PERCENT'">Phần trăm giảm (%)</span>
                  <span v-else>Số tiền giảm (VNĐ)</span>
                </template>
                <div class="flex items-center">
                  <template v-if="dataForm.discountType === 'MONEY'">
                    <ElCurrencyInput
                      v-model="dataForm.discountNumber"
                      :options="{ locale: 'vi-VN', precision: 0, autoDecimalMode: false, distractionFree: false }"
                      class="sk-u-w-full"
                      @input="calculatePreview"
                    />
                  </template>
                  <template v-else>
                    <el-input-number v-discount-percent
                      v-model="dataForm.discountNumber"
                      :min="0"
                      :max="100"
                      :precision="0"
                      controls-position="right"
                      class="sk-u-w-full"
                      @change="calculatePreview"
                    />
                  </template>
                  <div v-if="discountAmount > 0" class="erd-discount-amount ml-3">
                    -{{ formatMoney(discountAmount) }}
                  </div>
                </div>
              </el-form-item>
            </el-col>

            <!-- Thuế suất (chỉ hiển thị khi taxPercentage > 0) -->
            <el-col :span="12" v-if="Number(dataForm.taxPercentage) > 0">
              <el-form-item label="Thuế suất">
                <div class="erd-readonly-value">{{ Number(dataForm.taxPercentage) }}%</div>
              </el-form-item>
            </el-col>

            <!-- Thành tiền preview -->
            <el-col :span="24" v-if="!dataForm.hasFormula">
              <el-form-item>
                <template v-slot:label>Thành tiền</template>
                <div class="erd-preview-money">{{ formatMoney(previewSumMoney) }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- ══════════════════════════════════════════
             PHÂN KHU 2.5 – CHI TIẾT KHOẢN PHỤ (chỉ khi hasFormula = true)
             ══════════════════════════════════════════ -->
        <principal-override-table
          v-if="dataForm.hasFormula"
          :overrides="principalOverrides"
          :formula-expression="dataForm.formulaExpression"
          :loading="overrideLoading"
          :resetting="overrideResetting"
          @edit="openOverrideEditDialog"
          @reset="handleResetOverrides"
        />

        <!-- ══════════════════════════════════════════
             PHÂN KHU 3 – HÓA ĐƠN ĐIỆN TỬ
             ══════════════════════════════════════════ -->
        <div class="sk-panel mb-2">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--warning"><i class="el-icon-tickets" /></div>
            <div>
              <p class="sk-panel-title">Hóa đơn điện tử</p>
              <p class="sk-panel-subtitle">Cài đặt phát hành hóa đơn điện tử cho khoản thu này</p>
            </div>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <template v-slot:label>
                  Hóa đơn điện tử
                  <el-tooltip content="Bật nếu khoản thu cần phát hành hóa đơn điện tử" placement="top">
                    <i class="el-icon-question erd-help-icon ml-1" />
                  </el-tooltip>
                </template>
                <el-radio-group v-model="dataForm.issuingElectronicInvoices">
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </dialog-base>

    <!-- Dialog sửa giá khoản phụ -->
    <principal-override-edit-dialog
      ref="overrideEditDialog"
      @saved="onOverrideSaved"
    />
  </div>
</template>

<script>
import { discountPercentInput, hasOverLimitPercentDiscount, DISCOUNT_PERCENT_LIMIT_MESSAGE } from "@/utils/discountPercent";
import DialogBase from "@/components/DialogBase.vue";
import ElCurrencyInput from "@/components/ElCurrencyInput.vue";
import managingRevenueService from "@/services/tutition_v3/ManagingRevenueService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import {DEFAULT_UNITS} from "@/constant/tuitionConstant";
import PrincipalOverrideTable from "@/components/tutition_v3/dialog/PrincipalOverrideTable.vue";
import PrincipalOverrideEditDialog from "@/components/tutition_v3/dialog/PrincipalOverrideEditDialog.vue";
import {
  hasQuantityFraction,
  isQuantityPrecisionValid,
  toQuantityJsonNumber,
} from "@/components/tutition_v3/utils/quantity";



function defaultDataForm() {
  return {
    // read-only display fields
    revenueName: "",
    code: "",
    description: "",
    category: "IN",
    active: true,
    appliedTimeType: null,
    attendance: false,
    hasFormula: false,
    formulaExpression: null,
    formulaExpressionName: "",
    // editable fields (API ,7)
    DEFAULT_UNITS,
    id: null,
    price: 0,
    quantity: 1,
    unit: "",
    discount: false,
    discountType: null,
    discountNumber: null,
    issuingElectronicInvoices: false,
    numberUnit: 1,
    taxPercentage: null,
  };
}

export default {
  directives: { discountPercent: discountPercentInput },
  name: "EditRevenueDetailDialog",

  components: { DialogBase, ElCurrencyInput, PrincipalOverrideTable, PrincipalOverrideEditDialog },

  data() {
    const validateDiscountType = (rule, value, callback) => {
      if (this.dataForm.discount && !value) {
        callback(new Error("Vui lòng chọn loại giảm giá"));
      } else {
        callback();
      }
    };
    const validateDiscountNumber = (rule, value, callback) => {
      if (!this.dataForm.discount) return callback();
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập giá trị giảm"));
      }
      if (this.dataForm.discountType === "PERCENT") {
        const v = Number(value) || 0;
        if (v < 0 || v > 100) return callback(new Error("Phần trăm giảm phải trong khoảng 0–100"));
      }
      callback();
    };
    const validateQuantity = (rule, value, callback) => {
      if (!isQuantityPrecisionValid(value, this.allowDecimal)) {
        callback(new Error(this.allowDecimal
          ? "Số lượng chỉ được có tối đa 2 chữ số thập phân"
          : "Số lượng phải là số nguyên"));
        return;
      }
      callback();
    };

    return {
      visible: false,
      loading: false,
      allowDecimal: false,
      previewSumMoney: 0,
      discountAmount: 0,
      unitsList: [...DEFAULT_UNITS],
      dataForm: defaultDataForm(),
      // Principal Override state
      principalOverrides: [],
      overrideLoading: false,
      overrideResetting: false,
      formRules: {
        price: [
          { required: true, message: "Vui lòng nhập đơn giá", trigger: "blur" },
          { type: "number", min: 0, message: "Đơn giá phải >= 0", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "Vui lòng nhập số lượng", trigger: "blur" },
          { validator: validateQuantity, trigger: ["blur", "change"] },
        ],
        discountType:   [{ validator: validateDiscountType,   trigger: "change" }],
        discountNumber: [{ validator: validateDiscountNumber, trigger: "blur" }],
      },
    };
  },

  computed: {
    appliedTimeTypeLabel() {
      const map = {
        YEAR: 'Theo năm',
        MONTH: 'Theo tháng',
        TIME_PERIOD: 'Theo khoảng ngày',
        UNIT: 'Theo đơn vị',
      };
      return map[this.dataForm.appliedTimeType] || (this.dataForm.appliedTimeType || '—');
    },
  },

  watch: {
    "dataForm.unit"(val) {
      if (val && !this.unitsList.includes(val)) this.unitsList.push(val);
    },
  },

  methods: {
    // ─── Public API ──────────────────────────────────────────────
    /**
     * Mở dialog để sửa một bản ghi revenueItem (từ API getDetailById)
     * @param {Object} revenueItem - RevenueItemResponse từ API
     */
    open(revenueItem) {
      this.originalRevenueItem = revenueItem;
      this.allowDecimal = false;
      this.dataForm = {
        // read-only
        revenueName:               revenueItem.revenueName       || "",
        code:                      revenueItem.code              || "",
        description:               revenueItem.description       || "",
        category:                  revenueItem.category          || "IN",
        active:                    revenueItem.active            ?? true,
        appliedTimeType:           revenueItem.appliedTimeType   || null,
        attendance:                revenueItem.attendance        ?? false,
        hasFormula:                revenueItem.hasFormula        ?? false,
        formulaExpression:         revenueItem.formulaExpression || null,
        formulaExpressionName:     revenueItem.formulaExpressionName || null,

        // editable
        id:                        revenueItem.id,
        price:                     revenueItem.price             ?? 0,
        quantity:                  revenueItem.quantity === undefined ? 1 : revenueItem.quantity,
        unit:                      revenueItem.unit              || "",
        discount:                  revenueItem.discount          ?? false,
        discountType:              revenueItem.discountType      || null,
        discountNumber:            revenueItem.discountNumber    ?? null,
        issuingElectronicInvoices: revenueItem.issuingElectronicInvoices ?? false,
        numberUnit:                revenueItem.numberUnit        ?? 1,
        taxPercentage:             revenueItem.taxPercentage     || null,
      };
      this.allowDecimal = hasQuantityFraction(this.dataForm.quantity);

      if (this.dataForm.unit && !this.unitsList.includes(this.dataForm.unit)) {
        this.unitsList.push(this.dataForm.unit);
      }

      // Load principal overrides nếu có công thức
      this.principalOverrides = [];
      if (this.dataForm.hasFormula) {
        // Ưu tiên data từ response chi tiết (principalOverrides đã có sẵn)
        if (revenueItem.principalOverrides && revenueItem.principalOverrides.length > 0) {
          this.principalOverrides = revenueItem.principalOverrides;
        } else {
          // Fallback: gọi API riêng để load
          this.fetchPrincipalOverrides(revenueItem.id);
        }
      }

      this.calculatePreview();
      this.visible = true;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },

    handleClose() {
      this.visible = false;
      this.$refs.dataForm?.resetFields();
    },

    // ─── Submit ───────────────────────────────────────────────────
    handleSubmit() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;

        this.loading = true;
        try {
          const payload = {
            ...this.originalRevenueItem,
            id:                        this.dataForm.id,
            price:                     this.dataForm.price,
            quantity:                  toQuantityJsonNumber(this.dataForm.quantity),
            unit:                      this.dataForm.unit || null,
            discount:                  this.dataForm.discount,
            discountType:              this.dataForm.discount ? this.dataForm.discountType   : null,
            discountNumber:            this.dataForm.discount ? this.dataForm.discountNumber : null,
            issuingElectronicInvoices: this.dataForm.issuingElectronicInvoices,
            numberUnit:                this.dataForm.numberUnit,
          };

          if (hasOverLimitPercentDiscount(payload)) {
            NotifyMessage.leftCornerNotificationError(DISCOUNT_PERCENT_LIMIT_MESSAGE);
            return;
          }

          const res = await managingRevenueService.updateOne(payload);
          const responseData = res.data;

          if (responseData?.status === 200 && responseData?.code === "0") {
            if (responseData.data === false) {
              NotifyMessage.leftCornerNotificationError(
                "Khoản thu không còn tồn tại, vui lòng làm mới trang."
              );
            } else {
              NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công!");
            }
            this.visible = false;
            this.$emit("saved");
          } else {
            NotifyMessage.leftCornerNotificationError(
              responseData?.message || "Cập nhật thất bại!"
            );
          }
        } catch (err) {
          NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Cập nhật thất bại!"
          );
        } finally {
          this.loading = false;
        }
      });
    },

    // ─── Discount change ──────────────────────────────────────────
    onDiscountChange(val) {
      if (!val) {
        this.dataForm.discountType   = null;
        this.dataForm.discountNumber = null;
        this.discountAmount = 0;
      }
      this.calculatePreview();
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },

    handleAllowDecimalChange(value) {
      if (!value && hasQuantityFraction(this.dataForm.quantity)) {
        NotifyMessage.leftCornerNotificationWarning(
          "Vui lòng sửa số lượng về số nguyên trước khi tắt chế độ thập phân."
        );
        return;
      }
      this.allowDecimal = value;
      this.$nextTick(() => this.$refs.dataForm?.validateField("quantity"));
    },

    // ─── Preview tính tiền ────────────────────────────────────────
    calculatePreview() {
      const price    = Number(this.dataForm.price)    || 0;
      const quantity = Number(this.dataForm.quantity) || 0;
      let total = price * quantity;

      this.discountAmount = 0;
      if (this.dataForm.discount) {
        const dn = Number(this.dataForm.discountNumber) || 0;
        if (this.dataForm.discountType === "PERCENT") {
          this.discountAmount = (total * dn) / 100;
        } else if (this.dataForm.discountType === "MONEY") {
          this.discountAmount = dn;
        }
        total = Math.max(0, total - this.discountAmount);
      }
      const taxRate = Number(this.dataForm.taxPercentage) || 0;
      if (taxRate > 0) {
        total = total * (1 + taxRate / 100);
      }
      this.previewSumMoney = total;
    },

    // ─── Format helpers ───────────────────────────────────────────
    formatMoney(value) {
      if (value === null || value === undefined || value === "") return "—";
      return Number(value).toLocaleString("vi-VN") + " ₫";
    },

    // ─── Principal Override methods ───────────────────────────────

    /** Gọi API lấy danh sách override khoản phụ */
    async fetchPrincipalOverrides(idRevenueStudent) {
      this.overrideLoading = true;
      try {
        const res = await managingRevenueService.getPrincipalOverrides(idRevenueStudent);
        const responseData = res.data;
        if (responseData?.status === 200) {
          this.principalOverrides = responseData.data || [];
          if (this.originalRevenueItem) {
            this.originalRevenueItem.principalOverrides = this.principalOverrides;
          }
        }
      } catch (err) {
        // Không hiển thị lỗi nếu không load được – bảng sẽ rỗng
        this.principalOverrides = [];
      } finally {
        this.overrideLoading = false;
      }
    },

    /** Mở dialog sửa giá khoản phụ */
    openOverrideEditDialog() {
      this.$refs.overrideEditDialog.open(this.dataForm.id, this.principalOverrides);
    },

    /** Callback sau khi sửa override thành công */
    onOverrideSaved(updatedOverrides) {
      if (updatedOverrides) {
        this.principalOverrides = updatedOverrides;
        if (this.originalRevenueItem) {
          this.originalRevenueItem.principalOverrides = updatedOverrides;
        }
      } else {
        // Refresh lại từ API
        this.fetchPrincipalOverrides(this.dataForm.id);
      }
    },

    /** Reset override về mặc định */
    handleResetOverrides() {
      this.$confirm(
        "Bạn có chắc muốn reset giá khoản phụ về mặc định? Tất cả giá riêng sẽ bị hủy.",
        "Xác nhận reset",
        {
          confirmButtonText: "Đồng ý reset",
          cancelButtonText: "Hủy",
          type: "warning",
        }
      )
        .then(async () => {
          this.overrideResetting = true;
          try {
            const res = await managingRevenueService.resetPrincipalOverrides(this.dataForm.id);
            const responseData = res.data;
            if (responseData?.status === 200) {
              this.principalOverrides = responseData.data || [];
              if (this.originalRevenueItem) {
                this.originalRevenueItem.principalOverrides = this.principalOverrides;
              }
              NotifyMessage.leftCornerNotificationSuccess("Đã reset giá khoản phụ về mặc định!");
            } else {
              NotifyMessage.leftCornerNotificationError(
                responseData?.message || "Reset thất bại!"
              );
            }
          } catch (err) {
            NotifyMessage.leftCornerNotificationError(
              err?.response?.data?.message || "Reset thất bại!"
            );
          } finally {
            this.overrideResetting = false;
          }
        })
        .catch(() => {
          // User cancel – do nothing
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog";

/deep/ .el-input-number.sk-u-w-full { width: 100%; }
/deep/ .el-select.sk-u-w-full       { width: 100%; }

/* Read-only value display */
.erd-readonly-value {
  padding: 7px 11px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
  line-height: 1.5;
}

/* Help icon trong label */
.erd-help-icon {
  color: #64748b;
  font-size: 14px;
  vertical-align: middle;
}

/* Thành tiền preview (đồng bộ với TotalRevenueFormDialog) */
.erd-preview-money {
  padding: 10px 12px;
  width: 100%;
  text-align: right;
  background: #f0f4f8;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-weight: 700;
  font-size: 15px;
  color: #1d4ed8;
  font-variant-numeric: tabular-nums;
  box-sizing: border-box;
}

/* Giá trị giảm hiển thị bên cạnh input */
.erd-discount-amount {
  color: #dc2626;
  font-weight: 700;
  min-width: 120px;
  text-align: right;
  white-space: nowrap;
}


/* Biểu thức công thức */
.erd-formula {
  font-family: monospace;
  color: #0369a1;
  word-break: break-all;
}

/* Mô tả */
.erd-description {
  font-weight: 400;
  color: #475569;
}

/* Công thức đã dịch (read-only) */
.trf-formula-name {
  padding: 10px 12px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  font-size: 13.5px;
  color: #15803d;
  font-weight: 500;
  word-break: break-all;
}
</style>
